import { applyMiddleware, legacy_createStore as createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import reduce from "./reducers";

export type rootState = ReturnType<typeof store.getState>;
const store = createStore(reduce, composeWithDevTools(applyMiddleware()));
export default store;
